<script>
import Vue                                  from 'vue';
import { Bar }                              from 'vue-chartjs';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';

export default {
    extends: Bar,
    props: {
        chart: {
            type: Object,
            default: null
        },
        settings: {} 
    },
    data() {
        return {
            data: {},
            chartType: '',
            chartData: { },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                legend: { position: 'top' },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true
                        },
                        scaleLabel:{
                            display: false
                        },
                        stacked: true
                    }],
                    yAxes: [
                        { stacked: true }
                    ]
                }
            }
        }
    },
    created() {
        Vue.$log.info('※ VerticalBarChart.vue created data =>', this.chart);
        if(this.chart !== null) {
            this.chartType = this.chart.chartType;
            this.data = this.chart.chartData;
        };

        let labels = [],
            datasets = [];
        if(this.chartType === 'RE') {
            datasets = [
                {
                    label: 'Reprocess',
                    backgroundColor: '#364fc7',
                    barThickness: 30,
                    maxBarThickness: 40,
                    data: []
                }
            ];

            for(let i = 0; i < this.data.length; i++) {
                let cData = this.data[i];
                labels.push(cData.BOARD_NM);
                datasets[0].data.push(cData.RATE);
            };

        } else { // chartType == CU
            datasets = [
                {
                    label: 'Not, yet',
                    backgroundColor: '#364fc7',
                    barThickness: 30,
                    maxBarThickness: 40,
                    data: []
                },
                {
                    label: 'Read',
                    backgroundColor: '#60c0dc',
                    barThickness: 30,
                    maxBarThickness: 40,
                    data: []
                },
            ];

            if(this.chartType === 'CU') {
                datasets[0].label = 'Views';
                datasets[1].label = 'Users';
            };

            for(let i = 0; i < this.data.length; i++) {
                let cData = this.data[i];
                labels.push(cData.CONTENT_NM);
                datasets[0].data.push(cData.NOT_YET);
                datasets[1].data.push(cData.READ);
            };
        }

        Object.assign(this.chartData, {
            labels : labels,
            datasets: datasets
        });

        Object.assign(this.options, {
            title: {
                display: true,
                position: 'bottom',
                text: this.settings.TITLE
            }
        });
    },
    mounted () {
        this.renderChart(this.chartData, this.options);
    }
};
</script>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/dashboard/charts/VerticalBarChart.vue